import { Box, Card, Stack, Text } from '@mantine/core'
import Image from 'next/image'
import React from 'react'
import ImageFallback from './image_fallback'

const CharacterCard = ({ name, src, character, role }) => {
  const noImage = '/userholder.png'
  console.log('CharacterCard props:', { name, src, character, role })

  return (
    <Card
      p={0}
      radius={4}
      sx={{ backgroundColor: '#0E1922', borderBottom: '2px solid #7B39B6' }}
      h={270}
      w={180}
    >
      <Box sx={{ position: 'relative', width: '100%', height: '76%' }}>
        {src ? (
          <ImageFallback
            src={src}
            fallbackSrc={noImage}
            alt={`${name} - ${role}`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#0E1922',
              color: '#fff'
            }}
          >
            <Image src={noImage} width={30} height={30} alt={`${name} - ${role}`} />
          </Box>
        )}
      </Box>
      <Stack p={12} spacing={0} align="center">
        <Text size={12} tt="uppercase" color="white">
          {name}
        </Text>
        <Text
          size={10}
          tt="uppercase"
          fw="bolder"
          color="gray"
          align="center"
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            width: '100%',
            visibility: 'visible'
          }}
        >
          {character || role}
        </Text>
      </Stack>
    </Card>
  )
}

export default CharacterCard
